module.exports = __webpack_public_path__ + "img/rightarrowicon.9c7210ab.svg";